import { useMemo } from 'react';

import { ChronicDisease } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { MedicalInformationModal } from '../MedicalInformationModal/MedicalInformationModal';

import { ChronicDiseaseDetails } from './ChronicDiseaseDetails';
import { mapChronicDiseaseToMedicalInformationPreview } from './ChronicDiseaseDetailsModal.utils';

type ChronicDiseaseDetailsModalProps = {
   readonly onClose: VoidFunction;
   readonly onMedicalDataAccessAuthorizationUpdate?: VoidFunction;
   readonly chronicDisease: ChronicDisease;
};

export const ChronicDiseaseDetailsModal = (props: ChronicDiseaseDetailsModalProps): JSX.Element => {
   const medicalInformation = useMemo(() => mapChronicDiseaseToMedicalInformationPreview(props.chronicDisease), [
      props.chronicDisease,
   ]);

   return (
      <MedicalInformationModal
         medicalInformation={medicalInformation}
         onClose={props.onClose}
         onMedicalDataAccessAuthorizationUpdate={props.onMedicalDataAccessAuthorizationUpdate}
      >
         <ChronicDiseaseDetails chronicDisease={props.chronicDisease} />
      </MedicalInformationModal>
   );
};
